import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './styles/tokens.css'
import './styles/base.css'
import { App } from './App'
import { isIos } from './lib/pwa'
import { stopFocusZoom } from './lib/viewport'
import { captureInviteFromUrl } from './data/invites'

if (isIos()) stopFocusZoom()

// before the router reads the address, so an invite link lands on a clean one
captureInviteFromUrl()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
